import React from "react";
import {
  QueryInterventionsData,
  SubscribeNewInterventionsData,
} from "../../../utils/graphql/hooks/interventionsHooks";

export default function InterventionsDataManager() {
  QueryInterventionsData();
  SubscribeNewInterventionsData();
  return <></>;
}
